import React, { useEffect, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Font,
  Image,
} from "@react-pdf/renderer";
import { getEvaluationData } from "../testPrepDashboard/Api/DashboardApi";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../SAPPages/components/Loader/Loader";
import { Grid } from "@mui/material";
import { fDate } from "../../../utils2/formatTime";

// Inter
Font.register({
  family: "Inter",
  src: "/fonts/QS97R-6RI6D (2).ttf", // note the leading slash
  fontWeight: "bold",
});

Font.register({
  family: "Inter",
  src: "/fonts/AltisUniSA-Regular.ttf", // note the leading slash
  fontWeight: "normal",
});

// 🎨 Styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",

    // fontFamily: "Inter",
  },
  header: {
    color: "#fff",
    textAlign: "center",

    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "Inter",
    position: "absolute",
    left: 0,
    right: 0,
  },
  sectionTitle: {
    fontSize: 12,
    color: "#161719",

    fontWeight: "bold",
    fontFamily: "Inter",
  },
  boxContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 15,
    marginTop: 15,
    gap: 15,
  },
  box: {
    backgroundColor: "#FFF9FC",
    borderRadius: 8,
    flex: 1,
    border: "1px solid #ccc",
    padding: 10,
    border: "1px solid #F6E8EF",
  },

  lastBox: {
    backgroundColor: "#FFF9FC",
    borderRadius: 8,
    flex: 1,
    border: "1px solid #ccc",
    padding: 10,
    border: "1px solid #F6E8EF",
  },
  text: {
    fontSize: 10,
    marginBottom: 6,
    fontFamily: "Inter",
    fontWeight: "normal",
    color: "#3F424C",
  },
  subtext: {
    fontSize: 10,
    marginBottom: 4,
    fontFamily: "Inter",
    fontWeight: "normal",
    color: "#161719",
  },

  studentname: {
    fontSize: 14,
    marginBottom: 4,
    fontFamily: "Inter",
    fontWeight: "normal",
    color: "#161719",
  },
  scoreWrapper: {
    width: "100%",
    height: 60,
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  gradientImage: {
    position: "absolute", // PDF renderer allows this
    width: 50,
    height: 50,
    borderRadius: 50,
  },
  bigScore: {
    fontSize: 20,
    color: "#fff",
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Inter",
  },
  text1: {
    fontSize: 10,
    marginBottom: 4,
    fontFamily: "Inter",
    fontWeight: "normal",
    color: "#161719",
  },

  improvementBox: {
    backgroundColor: "#DBFCE7", // light green
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 6,
    alignSelf: "center", // shrink box to text width
    marginTop: 6,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  improvementText: {
    fontSize: 10,
    color: "#05533D", // dark green text
  },

  assessmentWrapper: {
    backgroundColor: "#FFF9FC",
    borderRadius: 8,

    border: "1px solid #ccc",
    padding: 10,
    border: "1px solid #F6E8EF",
  },

  secondassessmentWrapper: {
    backgroundColor: "#FFFFFF",
    borderRadius: 8,

    padding: 10,
    border: "1px solid #EAEAEA",
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#F4A460",
    padding: 5,
  },
  tableRow: {
    flexDirection: "row",

    padding: 5,
    marginRight: 10,
  },
  tableheader: {
    flex: 0.9,
    fontSize: 14,
    fontFamily: "Inter",
    color: "#FFFFFF",
    marginRight: 10,
  },
  tableCell: {
    flex: 0.9,
    fontSize: 11,
    fontFamily: "Inter",
    color: "#3F424C",
    marginRight: 10,
  },
  tableScore: {
    width: 60,
    textAlign: "center",
    fontSize: 10,
    marginRight: 10,
  },
  recommendation: {
    fontSize: 11,
    marginTop: 6,
    fontFamily: "Inter",
    color: "#3F424C",
    fontWeight: "normal",
  },

  barContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 4,
  },
  progressBackground: {
    width: 120,
    height: 6,
    backgroundColor: "#fde4f2",
    borderRadius: 4,
    marginRight: 8,
    position: "relative",
  },
  progressFill: (percentage) => ({
    width: `${percentage}%`,
    height: "100%",
    backgroundColor: "#3D025B",
    borderRadius: 4,
  }),
  fractionText: {
    fontSize: 10,
  },
});

const ProgressBar = ({ current, total }) => {
  const percentage = (current / total) * 100;
  return (
    <View style={styles.barContainer}>
      <View style={styles.progressBackground}>
        <View style={styles.progressFill(percentage)} />
      </View>
      {/* <Text style={styles.fractionText}>{`${current}/${total}`}</Text> */}
    </View>
  );
};

// 📄 PDF Document Component
const EvaluationScorePDF = (evalutionData) => {
  const data = evalutionData?.evalutionData;
  const feedback = data?.feedback;

  return (
    <Document>
      <Page size={{ width: 500, height: 650 }} style={styles.page}>
        {/* Header */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "#3D025B",
            padding: 10,
            position: "relative",
          }}
        >
          <View style={{ width: 47 }}>
            <Image src="/newdashboard/Demo/stmLogo.png" />
          </View>
          <Text style={styles.header}>Evaluation Score</Text>
        </View>

        <View style={{ padding: 20 }}>
          {/* Student Info + Performance */}
          <View style={styles.boxContainer}>
            {/* Student Info */}

            <View style={styles.box}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 7,
                  marginBottom: 10,
                }}
              >
                <View style={{ width: 13 }}>
                  <Image src="/newdashboard/Demo/Group 1171283473 (1).png" />
                </View>
                <Text style={[styles.sectionTitle]}>Student Information</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 9,
                  marginBottom: 5,
                }}
              >
                <View
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%", // half of width/height
                    overflow: "hidden", // ensures image is clipped
                  }}
                >
                  <Image
                    src="/newdashboard/Demo/Group 1171283716.png"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </View>

                <Text style={styles.studentname}>
                  {data?.enquiry_id?.first_name.trim()}{" "}
                  {data?.enquiry_id?.last_name}
                </Text>
              </View>

              <View style={{ marginTop: 5 }}>
                <Text style={styles.text}>
                  Trainer Name :{" "}
                  <Text style={styles.subtext}>
                    {data?.trainer_id?.first_name} {data?.trainer_id?.last_name}
                  </Text>{" "}
                </Text>
                <Text style={styles.text}>
                  Demo Date :{" "}
                  <Text style={styles.subtext}>{fDate(data?.demo_date)}</Text>{" "}
                </Text>
                <Text style={styles.text}>
                  Class Name :
                  <Text style={styles.subtext}> {data?.class_id?.name}</Text>{" "}
                </Text>
              </View>
            </View>

            {/* Current Performance */}
            <View style={styles.lastBox}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 7,
                  marginBottom: 5,
                }}
              >
                <View style={{ width: 15 }}>
                  <Image src="/newdashboard/Demo/Group 1171283483.png" />
                </View>
                <Text style={[styles.sectionTitle]}>Current Performance</Text>
              </View>

              <View style={styles.scoreWrapper}>
                <Image
                  src="/newdashboard/Demo/Group 1171283474.png"
                  style={styles.gradientImage}
                />

                <Text style={styles.bigScore}>
                  {data?.average_score < 10
                    ? `0${data.average_score}`
                    : data.average_score}
                </Text>
              </View>
              <Text style={[styles.text1, { textAlign: "center" }]}>
                Band Score Level
              </Text>
              <View style={styles.improvementBox}>
                <View style={{ width: 14 }}>
                  <Image src="/newdashboard/Demo/Vector (11).png" />
                </View>
                <Text style={styles.improvementText}>
                  Improvement Time: {data?.package_recommendation}
                </Text>
              </View>
            </View>
          </View>

          {/* Skills Assessment */}
          <View style={styles.assessmentWrapper}>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 5,
                marginBottom: 8,
              }}
            >
              <View style={{ width: 13, height: 18 }}>
                <Image src="/newdashboard/Demo/Layer_x0020_1.png" />
              </View>
              <Text style={styles.sectionTitle}>Skills Assessment</Text>
            </View>

            <View style={styles.secondassessmentWrapper}>
              <View>
                {/* Table Header */}
                <View style={styles.tableHeader}>
                  <Text
                    style={[
                      styles.tableCell,
                      {
                        color: "#fff",
                        fontFamily: "Inter",
                        fontWeight: "bold",
                        fontSize: 12,
                      },
                    ]}
                  >
                    Skills
                  </Text>
                  <Text
                    style={[
                      styles.tableScore,
                      {
                        color: "#fff",
                        fontFamily: "Inter",
                        fontWeight: "bold",
                        fontSize: 12,
                      },
                    ]}
                  >
                    Score
                  </Text>
                </View>

                {/* Table Rows */}
                {feedback?.map((item, idx) => (
                  <View style={styles.tableRow} key={idx}>
                    <Text style={styles.tableCell}>{item?.name}</Text>

                    <ProgressBar current={item?.val} total={10} />
                    <Text style={styles.tableScore}>{item?.val}/10</Text>
                  </View>
                ))}
              </View>
            </View>
          </View>

          {/* Recommendations */}
          <View style={[styles.assessmentWrapper, { marginTop: 14 }]}>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 5,
                marginBottom: 8,
              }}
            >
              <View style={{ width: 13 }}>
                <Image src="/newdashboard/Demo/Group 1171283484.png" />
              </View>
              <Text style={styles.sectionTitle}>Recommendations</Text>
            </View>

            <Text style={styles.recommendation}>
              {data?.recommendation_reason}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

// 📌 Main Viewer Component
const EvaluationScoreViewer = () => {
  const { evaluationId } = useParams(); // ✅ get id from URL

  const [isloading, setIsloading] = useState(true);
  const userId = localStorage.getItem("userId");
  const [evalutionData, setEvaluationData] = useState(null);

  const navigate = useNavigate();
  // const getEvalutionReport = async () => {
  //   setIsloading(true);
  //   try {
  //     const payload = {
  //       id: evaluationId,

  //       user_id: parseInt(userId),
  //     };

  //     const response = await getEvaluationData(payload);
  //     if (response.status === 200) {
  //       setEvaluationData(response?.data);

  //       setIsloading(false);
  //     } else if ([400, 401, 500].includes(response.status)) {
  //       setIsloading(false);
  //       setMessageError(response?.message);
  //     }
  //   } catch (error) {
  //     setIsloading(false);
  //     setMessageError("Internal Server Error");
  //     navigate("/page500")
  //   }
  // };

  // useEffect(() => {
  //   getEvalutionReport();
  // }, []);

  useEffect(() => {
    setIsloading(true);
    const storageKey = `evaluationData_${evaluationId}`;
    const stored = sessionStorage.getItem(storageKey);

    if (stored) {
      setEvaluationData(JSON.parse(stored));
    } else {
      console.warn("No evaluation data found in sessionStorage");
      // optionally fetch again if needed
    }
    setIsloading(false);
  }, [evaluationId]);
  return (
    <>
      {isloading ? (
        <Grid
          container
          height="100vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Loader text="Genarating Report..." />
        </Grid>
      ) : (
        <>
          <PDFViewer width="100%" height="700">
            <EvaluationScorePDF evalutionData={evalutionData} />
          </PDFViewer>
        </>
      )}
    </>
  );
};

export default EvaluationScoreViewer;
